import React from 'react'
import DOMPurify from 'dompurify';
import { sanitizeURLs } from '../utils/helpers';
const HTMLContent: React.FC<{ content: string }> = ({ content }) => {
    return (
        <div
            className={`content-wrapper text-dark-gray mh-100`}
        >
            <div
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(
                        sanitizeURLs(
                            typeof content === 'string'
                                ? content
                                : typeof content === 'object' && content !== null && 'text' in content
                                    ? (content as any).text ?? ''
                                    : ''
                        )
                    ),
                }}
            />
        </div>
    )
}

export default HTMLContent